<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="content-container">
            <SportipsButton toPage="Home" chevronLeft mobile-full-width>Retour à
              l'accueil</SportipsButton>
            <div class="text-h6 font-weight-bold my-3"><v-icon icon="mdi-swap-horizontal" color="primary"
                size="xs-small"></v-icon> Transfert d'inscription</div>

            <div v-if="error != ''">
              <v-alert border="start" border-color="red" density="compact">
                <span v-if="error == 'inscription_already_transfered'">Ce lien de
                  transfert a déjà été utilisé</span>
                <span v-else-if="error == 'transfert_request_not_found'">Cette demande
                  de transfert n'est pas valide</span>
                <span v-else-if="error == 'inscription_deleted'">Cette demande
                  de transfert n'est pas valide, car l'inscription d'origine a été remboursée.</span>
                <span v-else-if="error == 'transfert_dossard_disabled'">Le transfert
                  de dossard n'est pas autorisé sur cet évènement.</span>
                <span v-else-if="error == 'transfert_dossard_date_limit_reached'">Le
                  transfert de dossard n'est plus possible, la date limite est dépassée.</span>
                <span v-else>Une erreur inconnue est survenue</span>
              </v-alert>
              <div class="d-flex justify-center gap mt-3">
                <SportipsButton toPage="Home" mobile-full-width chevron>Retour à l'accueil
                </SportipsButton>
              </div>
            </div>
            <div v-else>
              <InformationTransferableInscription v-if="transferable_inscription.inscription != null"
                :inscription="transferable_inscription.inscription" @update_vague="update_vague">
              </InformationTransferableInscription>

              <div class="text-h6 font-weight-bold my-3"><v-icon icon="mdi-swap-horizontal" color="primary"
                  size="xs-small"></v-icon> Mon identité</div>

              <TransfertForm v-if="transferable_inscription.inscription != null"
                :transferable_inscription="transferable_inscription" class="mt-4"></TransfertForm>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import Transferable_Inscription from "@/classes/Transfert_Inscription/Transferable_Inscription.class";
import InformationTransferableInscription from "@/components/TransfertInscription/InformationTransferableInscription.vue";
import TransfertForm from "@/components/TransfertInscription/TransfertForm.vue";
export default {
  components: {
    InformationTransferableInscription,
    TransfertForm,
  },
  data() {
    return {
      error: "",
      transferable_inscription: new Transferable_Inscription(),
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    update_vague(id_vague) {
      this.transferable_inscription.inscription.id_vague_course = id_vague;
    },
  },

  async created() {
    this.error = "";
    if (!this.mainStore.module.autoriser_transfert_dossard) {
      this.error = "transfert_dossard_disabled";
    }
    if (this.mainStore.module.has_limite_transfert_dossard && this.$moment(this.mainStore.module.metadatas.limite_transfert_dossard).endOf("day").isBefore(this.$moment())) {
      this.error = "transfert_dossard_date_limit_reached";
    }

    if (this.$route.query.req && this.$route.query.req != "") {
      this.transferable_inscription.id_crypted = this.$route.query.req;
      let response = await this.transferable_inscription.fetch();



      if (!response[0]) {
        this.error = response[1];
      }

      if (this.transferable_inscription.valid_after_enddate == "1" && this.error == "transfert_dossard_date_limit_reached") {
        this.error = "";
      }
    }
  },
};
</script>

<style lang="scss" scoped></style>